module.exports = __webpack_public_path__ + "static/media/popup.1c23533a.svg";